webpackJsonp([156633155116014],{

/***/ 477:
/***/ (function(module, exports) {

	module.exports = {"data":{"contentfulMember":{"name":"Gary Andreassen","designation":"Founder","thumbnail":{"file":{"url":"//images.ctfassets.net/1o5ly3na7qu2/74XW8SGoCIs2uoY0eWkgoe/b6f34778f521430e6ab51a1b125fcccf/Gary.jpg"}},"content":{"content":"![MSA001A blog](//images.contentful.com/1o5ly3na7qu2/2qCLtRPNs4ek6e4Wiguiwo/f8298263fbcfd01e78a0ca6f0c0f6e7f/MSA001A_blog.JPG)\n\nGary Andreassen is the principle founder of the Manila Street Astronomers\n- MSA Founder\n- Data Scientist\n- Amateur Astronomer"}}},"pathContext":{"id":"c4IzyEm6j32O0SkGAOKewqO"}}

/***/ })

});


// WEBPACK FOOTER //
// path---member-gary-andreassen-26f4d408c460515b0cce.js